import { useAppSelector } from "../redux/hooks";
import { getAuthState } from "../redux/store/getState";

export default function useUser() {
  const { user } = useAppSelector(getAuthState);

  const permissions = user?.permissions;

  const isAdmin = permissions?.includes("admin");

  return {
    user,
    voucherBlockPermission: permissions?.includes("voucher.delete") || isAdmin,
    approvePermission: permissions?.includes("request.approve") || isAdmin,
    userEditPermission: permissions?.includes("user.edit") || isAdmin,
    userDeletePermission: permissions?.includes("user.delete") || isAdmin,
    examDeletePermission: permissions?.includes("exam.delete") || isAdmin,
    examEditPermission: permissions?.includes("exam.edit") || isAdmin,
    examCreatePermission: permissions?.includes("exam.create") || isAdmin,
    examinerEditPermission: permissions?.includes("examiner.edit") || isAdmin,
  };
}
